import OrderConditionFreightFieldView from './OrderConditionFreightFieldView';
import useOrderConditionFreightField from './hooks/useOrderConditionFreightField';
import { OrderConditionFreightFieldProps } from './orderConditionFreightField.types';

const OrderConditionFreightField = (props: OrderConditionFreightFieldProps) => {
  const viewProps = useOrderConditionFreightField(props);

  return <OrderConditionFreightFieldView {...viewProps} />;
};

export default OrderConditionFreightField;
